import axios from 'axios';
import Cookies from 'js-cookie';

// Créer une instance d'axios
const instance = axios.create({
    baseURL: 'https://go.vecos.us/reunice/API/v1',
    headers: { "Accept": "application/json, text/plain, */*", "Content-Type": "multipart/form-data" },
});

// Intercepteur de requête pour ajouter le token aux en-têtes
instance.interceptors.request.use((config) => {
    const token = Cookies.get('token'); // Récupérer le token d'accès depuis le cookie
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Intercepteur de réponse pour gérer les erreurs d'authentification
instance.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status === 401) {
        // Rediriger l'utilisateur vers la page de connexion en cas d'erreur 401
        Cookies.remove('token');
        Cookies.remove('refreshToken');
        Cookies.remove('userId');
        window.location.href = '/login';
    }

    return Promise.reject(error);
});

export default instance;
